import HENGE from "@henge-inc/global-types";
import HUI from "@henge-inc/ui/v1_2";
import { motion } from "motion/react";

export const UploadUnitPopover = () => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
      animate={{
        opacity: 1,
        top: "calc(50% - 16px)",
        transform: "translate(-50%, -100%)",
      }}
      exit={{
        opacity: 0,
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
      transition={HUI.framerMotionTransition.spring}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <HUI.Popover
        arrowFace={HENGE.POSITION_FACE.bottom}
        arrowAlign={HENGE.FLEX_ALIGN.center}
        contentDirection={HENGE.FLEX_DIRECTION.column}
        borderRadius={16}
      >
        <div className="max-w-48 pointer-events-none flex flex-col items-center justify-center gap-1 px-1">
          <HUI.Text
            kind={HENGE.TEXT_KIND.small}
            colour={HENGE.SEMANTIC_TEXT_COLOUR["text-primary"]}
            weight={HENGE.TEXT_WEIGHT.medium}
            whiteSpace={HENGE.TEXT_WHITE_SPACE.nowrap}
            lineHeight={HENGE.TEXT_LINE_HEIGHT.small}
            className="p-1"
          >
            Click to upload a 3D model
          </HUI.Text>
          {/*Recommended format*/}
          <HUI.Text
            kind={HENGE.TEXT_KIND.small}
            colour={HENGE.MAIN_COLOUR.green200}
            weight={HENGE.TEXT_WEIGHT.semibold}
            align={HENGE.TEXT_ALIGN.center}
            whiteSpace={HENGE.TEXT_WHITE_SPACE.normal}
            lineHeight={HENGE.TEXT_LINE_HEIGHT.medium}
          >
            Only .glb files supported
          </HUI.Text>
        </div>
      </HUI.Popover>
    </motion.div>
  );
};
